export const Hour = 60 * 60;
export const Day = Hour * 24;

export function now() {
  return Math.floor(new Date() / 1000);
}

export function sleep(ms) {
  return new Promise((accept) => {
    setTimeout(accept, ms);
  });
}

export function objToQs(object) {
  let result = '';
  for (const key in object) {
    if (!Object.prototype.hasOwnProperty.call(object, key)) { continue; }
    if (result) { result += '&'; }
    result += `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`;
  }
  return result;
}

export function qsToObj(qs) {
  const result = {};
  for (const entry of qs.replace(/^\?/, '').split('&')) {
    const pair = entry.split('=', 2);
    result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return result;
}

export function log(...args) {
  console.log(...args);
  let output = '';
  for (const arg of args) {
    if (output.length > 0) { output += ' '; }
    if (typeof arg === 'string') {
      output += arg;
    } else {
      output = JSON.stringify(arg);
    }
  }
  const el = document.querySelector('#message');
  el.innerHTML += `${output}<br>`;
  el.scrollTop = el.scrollHeight;
}
